import { FC } from 'react';
import { Card, Col, Grid, Image, Row, Typography } from 'antd';
import Text from 'antd/lib/typography/Text';

import { formatDateListArticels } from 'src/utils/func/format-date';

import classes from './article.module.less';

interface CardArticleInterface {
	data?: any;
}

const CardArticleLainnya: FC<CardArticleInterface> = (props) => {
	const { xs } = Grid.useBreakpoint();

	return (
		<div className={classes.containerCard}>
			<Row>
				{props?.data?.map((item: any) => {
					const dataPhase = item.type === 'pregnancy' ? 'kehamilan' : item.type === 'pre-pregnancy' ? 'pra-kehamilan' : 'pasca-kehamilan';
					return (
						<Col sm={24} md={22} lg={22} xl={22} xs={24} key={item.id}>
							<a
								href={
									`/${dataPhase}/${item.slug}`
								}
							>
								<span>
									<Card
										size="small"
										hoverable={false}
										className={classes.cards}
										style={{
											cursor: 'pointer',
										}}
										cover={
											<Image
												alt="example"
												src={item.media_images.original}
												className={classes.imageContainer}
												style={{
													width: xs ? '320x': '300px',
													height: '176px',
													borderRadius: '16px',
													// objectFit: 'cover',
												}}
												preview={false}
												loading='lazy'
											/>
										}
									>
										<Typography
											className={classes.title}
											style={{
												display: '-webkit-box',
												overflow: 'hidden',
												WebkitBoxOrient: 'vertical',
												WebkitLineClamp: 2,
											}}>
											{(item?.title)}
										</Typography>

										<Row>
											<Col
												className="d-flex align-items-center"
												style={{ marginLeft: xs ? '-10px' : '-15px' }}
											>
												<Text className="fs-12 fs-md-14">
													Diterbitkan pada {formatDateListArticels(item?.publish_date || '')}
												</Text>
											</Col>
										</Row>
										<Row>
											<Col
												className="d-flex align-items-center"
												style={{ marginLeft: xs ? '-10px' : '-15px' }}
											>
												{/* <Text className="fs-12 fs-md-14" style={{ color: '#9ca3aa' }}>
													{(item?.short_desc) || ''}
												</Text> */}
												<Typography
													className="fs-12 fs-md-14"
													style={{
														display: '-webkit-box',
														overflow: 'hidden',
														WebkitBoxOrient: 'vertical',
														WebkitLineClamp: 1,
														color: '#9ca3aa',
														textAlign: 'left',
													}}>
													{(item?.short_desc)}
												</Typography>
											</Col>
										</Row>
										{/* <Row>
											<Col
												className="d-flex align-items-center"
												style={{ marginLeft: xs ? '-5px' : '-15px' }}
											>
												<IconCustom iconName="heart" />
												<Text className="fs-12 fs-md-14 ml-2" style={{ color: '#9ca3aa' }}>
													{item.total_like}
												</Text>
											</Col>
											<Col className="d-flex align-items-center" style={{ marginLeft: '10px' }}>
												<IconCustom iconName="comment" />
												<Text className="fs-12 fs-md-14 ml-2" style={{ color: '#9ca3aa' }}>
													{item.total_comment}
												</Text>
											</Col>
										</Row> */}
									</Card>
								</span>
							</a>
						</Col>
					);
				})}
			</Row>
		</div>
	);
};

export default CardArticleLainnya;
